export default __webpack_public_path__ + "static/media/whiteTelegram.b7c7b914.svg";